<template>
    <div>
        <company-requests v-if="isCompany" :company="companyData" :user="companyUserData"></company-requests>
        <customer-requests v-if="isCustomer" :user="customerUserData" :requests="customerRequests"></customer-requests>
    </div>
</template>

<script>
    import CompanyRequests from '../components/organisms/my-pages-sections/company/requests/OrganismMyPagesRequestsListCompany.vue';
    import CustomerRequests from '../components/organisms/my-pages-sections/customer/requests/OrganismMyPagesRequestsListCustomer.vue';

    export default {
        props: [
            'isCustomer',
            'isCompany',
            'companyUserData',
            'companyData',
            'customerUserData',
            'customerRequests',
            'showAll'
        ],
        components: {
            CompanyRequests,
            CustomerRequests
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/my-pages-sublayouts/MyPagesRequests.vue